import React from 'react';
import styled from 'styled-components';
import {DiffItem} from './DiffMap';
import {DiffField} from './DiffField';
import {cell, fieldLabel} from './styles';
import {DetailsFieldValue, FieldOutputProps,} from '../../field/DetailsFieldValue';
import {Schema} from '../../types/Schema';
import {Field} from '../../types/Field';
import {colors} from '../../styles';
import {ResourceDetails} from '../../types/ResourceDetails';
import {FieldSection} from '../../sections/FieldSection';

type Props = FieldOutputProps & {
  schema: Schema;
  diffField: DiffField;
  diff?: DiffItem;
  oldData: ResourceDetails;
  newData: ResourceDetails;
};

export const DiffRecord: React.FC<Props> = (props) => {
  if (!props.diff) {
    return null;
  }
  
  const field = selectField(props.schema.fields, props.diffField);

  if (!field) {
    return null;
  }

  return (
    <Container>
      <Label>{field.label}</Label>
      <Cell>
        <DetailsFieldValue
          {...props}
          field={field}
          value={props.diff.oldValue}
          item={props.oldData}
        />
      </Cell>
      <Cell>
        <DetailsFieldValue
          {...props}
          field={field}
          value={props.diff.newValue}
          item={props.newData}
        />
      </Cell>
    </Container>
  );
};

function selectField(fields: Field[], diffField: DiffField): Field | undefined {
  const fid = diffField.dispValueId || diffField.id;

  for (const field of fields) {
    if (field.id === fid) {
      return field;
    }
  }
}

const Container = styled.tr`
  & td {
    background-color: ${colors.bodyColor};
  }

  &:nth-child(even) td {
    background-color: ${colors.bodyColorAlt};
  }
`;

const Label = styled.td`
  ${fieldLabel}
  ${cell}
`;

const Cell = styled.td`
  ${cell}
`;
